import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { responseInitialValues } from "@utils/response"
import { ResponseDefault, ResponsePattern } from "@utils/response/types"
import { Motorista } from "../interfaces/Motorista"

interface State {
    requestGetMotorista: ResponseDefault<Motorista>
    requestGetMotoristas: ResponseDefault<Motorista[]>
    requestCreateMotorista: ResponseDefault<any>
    requestUpdateMotorista: ResponseDefault<any>
    requestDeleteMotorista: ResponseDefault<any>
}

const initialState: State = {
    requestGetMotorista: responseInitialValues,
    requestGetMotoristas: responseInitialValues,
    requestCreateMotorista: responseInitialValues,
    requestUpdateMotorista: responseInitialValues,
    requestDeleteMotorista: responseInitialValues,
}

const requestMotoristaSlice = createSlice({
    name: 'requestMotorista',
    initialState,
    reducers: {
        setRequestGetMotoristaData: (state, action: PayloadAction<ResponsePattern<Motorista>>) => {
            state.requestGetMotorista.data = action.payload
            state.requestGetMotorista.loading = false
            state.requestGetMotorista.error = false
        },
        setRequestGetMotoristaLoading: (state) => {
            state.requestGetMotorista.loading = true
            state.requestGetMotorista.error = false
        },
        setRequestGetMotoristaError: (state) => {
            state.requestGetMotorista.loading = false
            state.requestGetMotorista.error = true
        },
        setRequestGetMotoristaMessage: (state, action: PayloadAction<string>) => {
            state.requestGetMotorista.message = action.payload
        },
        resetRequestGetMotorista: (state) => {
            state.requestGetMotorista = {...responseInitialValues}
        },

        setRequestGetMotoristasData: (state, action: PayloadAction<ResponsePattern<Motorista[]>>) => {
            state.requestGetMotoristas.data = action.payload
            state.requestGetMotoristas.loading = false
            state.requestGetMotoristas.error = false
        },
        setRequestGetMotoristasLoading: (state) => {
            state.requestGetMotoristas.loading = true
            state.requestGetMotoristas.error = false
        },
        setRequestGetMotoristasError: (state) => {
            state.requestGetMotoristas.loading = false
            state.requestGetMotoristas.error = true
        },
        setRequestGetMotoristasMessage: (state, action: PayloadAction<string>) => {
            state.requestGetMotoristas.message = action.payload
        },
        resetRequestGetMotoristas: (state) => {
            state.requestGetMotoristas = {...responseInitialValues}
        },

        setRequestCreateMotoristaData: (state, action: PayloadAction<any>) => {
            state.requestCreateMotorista.data = action.payload
            state.requestCreateMotorista.loading = false
            state.requestCreateMotorista.error = false
        },
        setRequestCreateMotoristaLoading: (state) => {
            state.requestCreateMotorista.loading = true
            state.requestCreateMotorista.error = false
        },
        setRequestCreateMotoristaError: (state) => {
            state.requestCreateMotorista.loading = false
            state.requestCreateMotorista.error = true
        },
        setRequestCreateMotoristaMessage: (state, action: PayloadAction<string>) => {
            state.requestCreateMotorista.message = action.payload
        },
        resetRequestCreateMotorista: (state) => {
            state.requestCreateMotorista = {...responseInitialValues}
        },

        setRequestUpdateMotoristaData: (state, action: PayloadAction<any>) => {
            state.requestUpdateMotorista.data = action.payload
            state.requestUpdateMotorista.loading = false
            state.requestUpdateMotorista.error = false
        },
        setRequestUpdateMotoristaLoading: (state) => {
            state.requestUpdateMotorista.loading = true
            state.requestUpdateMotorista.error = false
        },
        setRequestUpdateMotoristaError: (state) => {
            state.requestUpdateMotorista.loading = false
            state.requestUpdateMotorista.error = true
        },
        setRequestUpdateMotoristaMessage: (state, action: PayloadAction<string>) => {
            state.requestUpdateMotorista.message = action.payload
        },
        resetRequestUpdateMotorista: (state) => {
            state.requestUpdateMotorista = {...responseInitialValues}
        },

        setRequestDeleteMotoristaData: (state, action: PayloadAction<any>) => {
            state.requestDeleteMotorista.data = action.payload
            state.requestDeleteMotorista.loading = false
            state.requestDeleteMotorista.error = false
        },
        setRequestDeleteMotoristaLoading: (state) => {
            state.requestDeleteMotorista.loading = true
            state.requestDeleteMotorista.error = false
        },
        setRequestDeleteMotoristaError: (state) => {
            state.requestDeleteMotorista.loading = false
            state.requestDeleteMotorista.error = true
        },
        setRequestDeleteMotoristaMessage: (state, action: PayloadAction<string>) => {
            state.requestDeleteMotorista.message = action.payload
        },
        resetRequestDeleteMotorista: (state) => {
            state.requestDeleteMotorista = {...responseInitialValues}
        },
    }
})

const actions = requestMotoristaSlice.actions

export const requestGetMotoristaActions = {
    data: actions.setRequestGetMotoristaData,
    loading: actions.setRequestGetMotoristaLoading,
    error: actions.setRequestGetMotoristaError,
    message: actions.setRequestGetMotoristaMessage,
    reset: actions.resetRequestGetMotorista,
}

export const requestGetMotoristasActions = {
    data: actions.setRequestGetMotoristasData,
    loading: actions.setRequestGetMotoristasLoading,
    error: actions.setRequestGetMotoristasError,
    message: actions.setRequestGetMotoristasMessage,
    reset: actions.resetRequestGetMotoristas,
}

export const requestCreateMotoristaActions = {
    data: actions.setRequestCreateMotoristaData,
    loading: actions.setRequestCreateMotoristaLoading,
    error: actions.setRequestCreateMotoristaError,
    message: actions.setRequestCreateMotoristaMessage,
    reset: actions.resetRequestCreateMotorista,
}

export const requestUpdateMotoristaActions = {
    data: actions.setRequestUpdateMotoristaData,
    loading: actions.setRequestUpdateMotoristaLoading,
    error: actions.setRequestUpdateMotoristaError,
    message: actions.setRequestUpdateMotoristaMessage,
    reset: actions.resetRequestUpdateMotorista,
}

export const requestDeleteMotoristaActions = {
    data: actions.setRequestDeleteMotoristaData,
    loading: actions.setRequestDeleteMotoristaLoading,
    error: actions.setRequestDeleteMotoristaError,
    message: actions.setRequestDeleteMotoristaMessage,
    reset: actions.resetRequestDeleteMotorista,
}

export default requestMotoristaSlice.reducer